import { createMuiTheme } from "@material-ui/core/styles"

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#5d99f8",
      contrastText: "#fff",
    },
    secondary: {
      main: "#ffa19f",
      contrastText: "#fff",
    },
    background: {
      default: "#f7f7f7",
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: [
      "galano_grotesqueregular",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
})

export default theme
